import { createReducer } from 'redux-act';
import { fetchYear, failFetchYear, successFetchYear } from '../actions/year';

//初期状態
const initial = {
  isFetching: false,
  error: undefined,
  test_date: undefined,
};

const data = createReducer(
  {
    [failFetchYear]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        test_date: undefined,
        error: err,
      }),
    [fetchYear]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        test_date: undefined,
        error: undefined,
      }),
    [successFetchYear]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        data: payload,
        error: undefined,
      }),
  },
  initial
);

export default data;



// WEBPACK FOOTER //
// ./src/reducers/year.js